function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { useTranslation } from 'react-i18next';
import SettingsItem from '../../../SettingsItem';
import SectionTitle from '../../../SectionTitle';
import { RowsPerPage } from './components';

var TableSettings = function TableSettings(_ref) {
  var widgetSettings = _ref.widgetSettings,
      chartSettings = _ref.chartSettings,
      onUpdateWidgetSettings = _ref.onUpdateWidgetSettings,
      onUpdateChartSettings = _ref.onUpdateChartSettings,
      hiddenOptions = _ref.hiddenOptions;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return React.createElement("div", null, React.createElement(SectionTitle, {
    title: t('widget_customization_table_settings.title')
  }), !(hiddenOptions === null || hiddenOptions === void 0 ? void 0 : hiddenOptions.card) && React.createElement(SettingsItem, {
    id: "table-card",
    label: t('widget_customization_card_settings.label'),
    isEnabled: widgetSettings.card.enabled,
    onChange: function onChange(cardEnabled) {
      onUpdateWidgetSettings(_objectSpread(_objectSpread({}, widgetSettings), {}, {
        card: _objectSpread(_objectSpread({}, widgetSettings.card), {}, {
          enabled: cardEnabled
        })
      }));
    }
  }), React.createElement(SettingsItem, {
    id: "table-pagination",
    isEnabled: chartSettings.pagination,
    label: t('widget_customization_table_settings.pagination'),
    onChange: function onChange(pagination) {
      onUpdateChartSettings(_objectSpread(_objectSpread({}, chartSettings), {}, {
        pagination: pagination
      }));
    }
  }), React.createElement(RowsPerPage, {
    rowsPerPage: chartSettings.rowsPerPage,
    isPaginationEnabled: chartSettings.pagination,
    onChange: function onChange(rowsPerPage) {
      return onUpdateChartSettings(_objectSpread(_objectSpread({}, chartSettings), {}, {
        rowsPerPage: rowsPerPage
      }));
    }
  }), React.createElement(SettingsItem, {
    id: "table-selectable-rows",
    isEnabled: chartSettings.rowsSelection,
    label: t('widget_customization_table_settings.multiple_rows_selection'),
    onChange: function onChange(rowsSelection) {
      onUpdateChartSettings(_objectSpread(_objectSpread({}, chartSettings), {}, {
        rowsSelection: rowsSelection
      }));
    }
  }));
};

export default TableSettings;